import React from "react";
import AuthorizationError from "../../../components/authorizationError/AuthorizationError";

const AuthorizeError: React.FC = () => {
    return(
        <AuthorizationError />
    )
}

export default AuthorizeError;